var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5S40.2,9.5,78,9.5s68.5,30.7,68.5,68.5S115.8,146.5,78,146.5z M78,14.3 c-35.1,0-63.7,28.6-63.7,63.7c0,35.1,28.6,63.7,63.7,63.7c35.1,0,63.7-28.6,63.7-63.7C141.7,42.9,113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.3,113.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,113.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 81,
    cy: 114,
    rx: 26,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.4,52.6c4.4,4.5,8.7,9,13.1,13.5c0.2-0.8,0.4-1.7,0.7-2.5c-5.8,1.7-11,5.1-14.8,9.8c-1.2,1.5,0.9,3.6,2.1,2.1 c3.5-4.3,8.1-7.5,13.4-9c1.1-0.3,1.5-1.7,0.7-2.5c-4.4-4.5-8.7-9-13.1-13.5C53.2,49.1,51.1,51.2,52.4,52.6L52.4,52.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.5,50.5c-4.4,4.5-8.7,9-13.1,13.5c-0.8,0.8-0.4,2.2,0.7,2.5c5.3,1.6,10,4.7,13.4,9c1.2,1.5,3.3-0.6,2.1-2.1 c-3.8-4.7-9-8.1-14.8-9.8c0.2,0.8,0.4,1.7,0.7,2.5c4.4-4.5,8.7-9,13.1-13.5C108,51.2,105.9,49.1,104.5,50.5L104.5,50.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,34c2.8,2.4,5.6,4.7,8.5,7.1c0.6,0.5,1.5,0.6,2.1,0c0.5-0.6,0.6-1.6,0-2.1c-2.8-2.4-5.6-4.7-8.5-7.1 c-0.6-0.5-1.5-0.6-2.1,0C5.3,32.4,5.2,33.5,5.8,34L5.8,34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.4,16.6c1.3,2.9,3.3,5.4,5.8,7.4c0.6,0.5,1.5,0.6,2.1,0c0.5-0.5,0.6-1.6,0-2.1c-0.6-0.5-1.1-1-1.7-1.5 c-0.5-0.5-1.1-1.1-1.5-1.7c0.1,0.1,0.1,0.2,0,0c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.3-0.4-0.6-0.6-0.9 c-0.4-0.7-0.8-1.3-1.1-2c-0.3-0.7-1.4-0.9-2.1-0.5C21.2,15,21,15.8,21.4,16.6L21.4,16.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.6,3.9c1.6,3.1,3.3,6.1,4.9,9.2c0.4,0.7,1.4,1,2.1,0.5c0.7-0.5,0.9-1.3,0.5-2.1c-1.6-3.1-3.3-6.1-4.9-9.2 c-0.4-0.7-1.4-1-2.1-0.5C41.4,2.3,41.2,3.2,41.6,3.9L41.6,3.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.4,22.6c2.1-2.1,4.2-4.2,6.4-6.4c0.6-0.6,0.6-1.6,0-2.1c-0.6-0.5-1.5-0.6-2.1,0c-2.1,2.1-4.2,4.2-6.4,6.4 c-0.6,0.6-0.6,1.6,0,2.1C129.9,23.1,130.8,23.2,131.4,22.6L131.4,22.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143,42.9c2.3-3.3,4.6-6.6,6.9-10c0.5-0.7,0.1-1.7-0.5-2.1c-0.7-0.4-1.6-0.1-2.1,0.5c-2.3,3.3-4.6,6.6-6.9,10 c-0.5,0.7-0.1,1.7,0.5,2.1C141.7,43.8,142.5,43.5,143,42.9L143,42.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110,14.9c2.3-3.3,4.6-6.6,6.9-10c0.5-0.7,0.1-1.7-0.5-2.1c-0.7-0.4-1.6-0.1-2.1,0.5c-2.3,3.3-4.6,6.6-6.9,10 c-0.5,0.7-0.1,1.7,0.5,2.1C108.7,15.8,109.5,15.5,110,14.9L110,14.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress6);
export default __webpack_public_path__ + "static/media/Stress6.decba3151bc669c3fe7630ad19abcf8f.svg";
export { ForwardRef as ReactComponent };